// extracted by mini-css-extract-plugin
export default {"content":"ArchiveStep_content__UqKwD"};